{
    "NAME": "CallRecIntegration",
    "AddCallRecIntegrationTitle": "Adicionar integração de gravação de chamadas",
    "ModifyCallRecIntegrationTitle": "Modificar a integração da gravação de chamadas",
    "TabGeneralTitle": "Geral",
    "TabScopeAssignmentsTitle": "Atribuições de âmbito",
    "TabApiCommunicationsTitle": "Api Comunicações",
    "TabDubberCommunicationsTitle": "Dubber Communications",
    "IdentifierGUID": "Identificador (GUID):",
    "IdentifierGUIDPlaceholder": "[Auto Atribuído]",
    "IntegrationType": "Tipo de integração:",
    "IntegrationType_1": "[Tipo desconhecido ou não definido]",
    "IntegrationType_2": "Dubber Corporation Limited",
    "ModifyCallRecIntegrationDescriptionFormLabel": "Descrição:",
    "DubberApiComSettingsLocationUrls": "URL de localização do Dubber:",
    "ApiComSettingsIPAddrOne": "Endereço IP 1 (PRINCIPAL):",
    "ApiComSettingsIPAddrTwo": "Endereço IP 2 (SECUNDÁRIO):",
    "ApiComSettingsAuthDetailsMainTitle": "Detalhes da autenticação (PRINCIPAL)",
    "ApiComSettingsAuthDetailsMainUserName": "Nome de utilizador (MAIN):",
    "ApiComSettingsAuthDetailsMainUserPassword": "Palavra-passe (MAIN):",
    "ApiComSettingsAuthDetailsSecondaryTitle": "Detalhes de autenticação (SECUNDÁRIO):",
    "ApiComSettingsAuthDetailsSecondaryUserName": "Nome de utilizador (secundário):",
    "ApiComSettingsAuthDetailsSecondaryUserPassword": "Palavra-passe (secundária):",
    "ApiComSettingsApiParamOne": "Parâmetro API 1:",
    "ApiComSettingsApiParamTwo": "Parâmetro API 2:",
    "DubberComSettingsApiParamOne": "Nome da conta (PARTE DE RASTREIO):",
    "DubberComSettingsApiParamTWO": "Utilizador da conta \/ E-MAIL (OPCIONAL):",
    "DubberComSettingsTitle": "Definições de comunicação do Dubber",
    "DubberComSettingsLocationURL": "URL de localização do Dubber:",
    "DubberComSettingsDevAuthTitle": "Autenticação de programador",
    "DubberComSettingsDevAuthUserName": "Nome de utilizador (MASHERYID KEY):",
    "DubberComSettingsDevAuthUserPassword": "Palavra-passe (MASHERYID SECRET):",
    "DubberComSettingsAccountApiAuthTitle": "Autenticação da API da conta",
    "DubberComSettingsAccountApiAuthUserName": "Nome de utilizador (API AUTH ID):",
    "DubberComSettingsAccountApiAuthUserPassword": "Palavra-passe (API AUTH TOKEN):",
    "DubberComSettingAccountName": "Nome da conta (parte final)",
    "DubberComSettingsAccountUserEmail": "Utilizador da conta \/ E-mail (OPCIONAL)",
    "CallRecIntegrationAddModify_UnknownOrDeleted": "[Desconhecido ou Suprimido]",
    "CallRecIntegrationAddModify_ServerErrorTitle": "Erros de validação",
    "CallRecIntegrationAddModify_ValidationWarning": "Certifique-se de que todos os campos estão corretamente preenchidos",
    "CallRecIntegrationAddModify_ButtonHelpLabel": "Ajuda?",
    "CallRecIntegrationAddModify_ButtonSubmitLabel": "Guardar",
    "CallRecIntegrationAddModify_ButtonCancelLabel": "Cancelar",
    "CallRecIntegrationAddModify_PromptMessage": "Tem a certeza de que pretende fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "CallRecIntegrationAddModify_PromptConfirm": "Sim",
    "CallRecIntegrationAddModify_PromptCancel": "Cancelar",
    "Error_TestIntegration_Timeout": "O registo de integração de testes expirou",
    "InputField_Change_Username": "[Alterar nome de utilizador]",
    "InputField_Change_Password": "[Alterar palavra-passe]",
    "DubberComSettings_Parameters": "Parâmetros",
    "DubberComSettings_TestIntegrationAuth": "Autenticação de Integração de Teste",
    "DubberSuccessfullIntegration": "As definições de comunicação da integração de gravação de chamadas funcionam com sucesso"
}